module.exports = __webpack_public_path__ + "img/limitless-text.43e3e15f.svg";